import { RecordDetails } from "./RecordDetails";

export default RecordDetails